// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HubspotProvider, useHubspotForm } from "@store/Library/Widgets/ContactUs/HubSpot/hubspotScript";
import React from "react";

const enum fields {
    scriptSource = "scriptSource",
    portalId = "portalId",
    formId = "formId",
    gtmId = "gtmId",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.scriptSource]: string;
        [fields.portalId]: string;
        [fields.formId]: string;
        [fields.gtmId]: string;
    };
}

const HubSpotForm = ({ fields }: OwnProps) => {
    const { scriptSource, portalId, formId, gtmId } = fields;
    return (
        <HubspotProvider scriptSource={scriptSource}>
            <HubSpotFormComponent portalId={portalId} formId={formId} gtmId={gtmId} />
        </HubspotProvider>
    );
};

type HubSpotFormComponentProps = {
    portalId: string;
    formId: string;
    gtmId: string;
};

const HubSpotFormComponent = ({ portalId, formId, gtmId }: HubSpotFormComponentProps) => {
    const { loaded, error, formCreated } = useHubspotForm({
        portalId,
        formId,
        target: "#my-hubspot-form",
        onFormReady: form => {
            if (gtmId && gtmId !== "") {
                (function (window, document, currentDataLayer, tagId) {
                    (window as any)[currentDataLayer] = window?.dataLayer || [];
                    (window as any)[currentDataLayer].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
                    (window as any)[currentDataLayer].push({ hs_form: formId });

                    const scriptNode = document.createElement("script");
                    const dataLayer = currentDataLayer !== "dataLayer" ? `&l=${currentDataLayer}` : "";
                    scriptNode.setAttribute("async", "true");
                    scriptNode.setAttribute("src", `https://www.googletagmanager.com/gtm.js?id=${tagId}${dataLayer}`);

                    form.appendChild(scriptNode, form);
                })(window, document, "dataLayer", gtmId);
            }
        },
    });

    return (
        <div>
            <div id="my-hubspot-form"></div>
        </div>
    );
};

const widgetModule: WidgetModule = {
    component: HubSpotForm,
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.scriptSource,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.portalId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.formId,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.gtmId,
                editorTemplate: "TextField",
                defaultValue: "GTM-NCMWLSX",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
